/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Edit_Details_HintInputs */

const cs_workflow_edit_details_hint = /** @type {(inputs: Workflow_Edit_Details_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název, popis a zda je workflow aktivní.`)
};

const en_workflow_edit_details_hint = /** @type {(inputs: Workflow_Edit_Details_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, description, and whether this workflow is active.`)
};

/**
* | output |
* | --- |
* | "Name, description, and whether this workflow is active." |
*
* @param {Workflow_Edit_Details_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_edit_details_hint = /** @type {((inputs?: Workflow_Edit_Details_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Edit_Details_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_edit_details_hint(inputs)
	return cs_workflow_edit_details_hint(inputs)
});